export default "__VITE_ASSET__6Wl4eaSN__"